export enum ResponsiveSize {
  SCREEN_XL_DESKTOP = '(min-width: 1400px)',
  SCREEN_L_LAPTOP = '(min-width: 1136px) and (max-width: 1399px)',
  SCREEN_M_TABLET = '(min-width: 600px) and (max-width: 1135px)',
  SCREEN_S_MOBILE = '(max-width: 599px)',
}
